import TeamInvitationBadge from './TeamInvitationBadge';

export default TeamInvitationBadge;
